import React, { useEffect, useRef, useState } from 'react';

const ScrollBox3D = () => {
  const boxRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (boxRef.current) {
        const element = boxRef.current;
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Calculate scroll progress for this element (0 to 1)
        const elementTop = rect.top;
        const elementHeight = rect.height;
        const progress = Math.max(0, Math.min(1, 
          (windowHeight - elementTop) / (windowHeight + elementHeight)
        ));
        
        setScrollProgress(progress);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Animação mais fluida e profissional
  const scale = 0.75 + (scrollProgress * 0.25); // Scale from 0.75 to 1.0 (mais suave)
  const rotateY = -15 + (scrollProgress * 30); // Rotate from -15 to 15 degrees (menos extremo)
  const rotateX = 5 - (scrollProgress * 10); // Rotate from 5 to -5 degrees (mais sutil)
  const translateY = (1 - scrollProgress) * 50; // Move up menos drasticamente

  return (
    <div 
      ref={boxRef}
      className="relative bg-white py-8 sm:py-12 overflow-hidden z-20"
      style={{
        perspective: '2000px',
      }}
    >
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div 
          className="absolute top-1/4 -left-32 w-64 h-64 bg-[#1FA2FF]/10 rounded-full blur-3xl"
          style={{
            transform: `translateY(${scrollProgress * -30}px)`,
            transition: 'transform 0.2s ease-out',
          }}
        />
        <div 
          className="absolute bottom-1/4 -right-32 w-96 h-96 bg-[#0077C8]/10 rounded-full blur-3xl"
          style={{
            transform: `translateY(${scrollProgress * 30}px)`,
            transition: 'transform 0.2s ease-out',
          }}
        />
      </div>

      {/* 3D Box Container */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="flex flex-col items-center gap-4 sm:gap-6">
          {/* Title positioned above the box - OUTSIDE 3D transform */}
          <h2 
            className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#071028] text-center px-4 animate-fade-in-up"
            style={{
              opacity: scrollProgress > 0.2 ? 1 : 0,
              transform: `translateY(${scrollProgress > 0.2 ? 0 : 20}px)`,
              transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
            }}
          >
            Embalamento Profissional
          </h2>
          
          {/* 3D Box Image - Maior e mais fluido */}
          <div 
            className="relative w-full max-w-4xl"
            style={{
              transform: `
                translateY(${translateY}px)
                rotateX(${rotateX}deg)
                rotateY(${rotateY}deg)
                scale(${scale})
              `,
              transformStyle: 'preserve-3d',
              transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              willChange: 'transform',
            }}
          >
            {/* Enhanced Glow effect behind box with shadow */}
            <div 
              className="absolute inset-0 blur-3xl opacity-30"
              style={{
                background: 'radial-gradient(circle, #1FA2FF 0%, #0077C8 50%, transparent 70%)',
                transform: `scale(${0.9 + scrollProgress * 0.2}) translateY(30px)`,
                transition: 'transform 0.4s ease-out',
              }}
            />
            
            {/* Box Image with enhanced shadow */}
            <img
              src="https://customer-assets.emergentagent.com/job_mudancas-pro/artifacts/olqcvfia_ChatGPT%20Image%2029%20de%20nov.%20de%202025%2C%2001_14_23.png"
              alt="Embalamento Profissional - Marcelo Carvalho Transportes"
              className="relative z-10 w-full h-auto"
              style={{
                filter: `brightness(${1 + scrollProgress * 0.08}) drop-shadow(0 20px 40px rgba(7, 16, 40, 0.25))`,
                transition: 'filter 0.3s ease-out',
              }}
            />

            {/* Floating particles effect - mais sutil */}
            <div className="absolute inset-0 pointer-events-none opacity-50">
              {[...Array(6)].map((_, i) => (
                <div
                  key={i}
                  className="absolute w-1.5 h-1.5 bg-[#1FA2FF]/40 rounded-full blur-sm"
                  style={{
                    top: `${25 + (i * 12)}%`,
                    left: `${15 + (i * 12)}%`,
                    transform: `translateY(${Math.sin(scrollProgress * Math.PI * 2 + i) * 15}px)`,
                    opacity: scrollProgress * 0.5,
                    transition: 'all 0.4s ease-out',
                  }}
                />
              ))}
            </div>
          </div>

          {/* Description below box - sempre visível */}
          <p 
            className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto text-center px-4 leading-relaxed"
            style={{
              opacity: scrollProgress > 0.3 ? 1 : 0,
              transform: `translateY(${scrollProgress > 0.3 ? 0 : 15}px)`,
              transition: 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s',
            }}
          >
            Tomamos todos os cuidados possíveis para transportar seus bens com segurança máxima.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScrollBox3D;
